const _name = 'CHART';

const GRAPH_MODE = {
    default: 0,
    merge: 1,
    path: 2
}

const GRAPH_TYPE = {
    star: "star",
    tree: "tree",
    branch: "branch",
    oriented: "oriented" //There is no option to choose oriented. Why do we have it?
}

const LOAD_TYPE = {
    initial: "initial",
    common: "common",
    reload: "reload",
}

const VISIBILITY_TYPE = {
    visible: "visible",
    hidden: "hidden",
    deleted: "deleted",
}

export { _name, GRAPH_MODE, GRAPH_TYPE, LOAD_TYPE, VISIBILITY_TYPE };

